import React, { forwardRef } from "react";
import Info from "../assets/icons/ic_info.svg";

const Input = forwardRef(
  (
    {
      label,
      name,
      value,
      disabled,
      onChange,
      placeholder,
      type = "text",
      error,
      onKeyDown,
      onFocus,
      icon,
      onBlur,
      min,
      className,
      marginBottom,
      required, // ✅ new prop
    },
    ref
  ) => (
    <div className={`${marginBottom ? marginBottom : "mb-4"}  w-full`}>
      <label
        className={`block text-inputColor text-sm font-normal ${
          label ? "mb-1" : ""
        }`}
      >
        {label}
        {required && <span className="text-red-500 pl-1">*</span>}{" "}
      </label>
      <div className="relative">
        <input
          type={type}
          title={value ?? ""}
          name={name}
          value={value ?? ""}
          disabled={disabled}
          onBlur={onBlur}
          onFocus={onFocus}
          min={min} // ✅ important: forward min
          onChange={onChange}
          onKeyDown={onKeyDown}
          ref={ref}
          placeholder={placeholder}
          className={`text-sm font-normal text-activeTabColor w-full border-[0.5px] px-3 py-2 rounded-md ${className} focus:outline-none focus:ring-2 bg-transparent ${
            error
              ? "border-error ring-red-300"
              : "border-inputBorder focus:ring-primary"
          } ${icon ? "pr-10" : ""}`}
        />
        {icon && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2">
            {typeof icon === "string" ? <img src={icon} alt="icon" /> : icon}
          </div>
        )}
      </div>
      {error && (
        <div className="flex gap-1 w-fit text-[10px] bg-red-100 text-red-600 mt-1 rounded p-[3px]">
          <img src={Info} alt="info" />
          {error}
        </div>
        // bg-error text-white
      )}
    </div>
  )
);
export default Input;
